(function () {
  'use strict';

  // The Frengee app relocates its rendered .frengee-pickup-block card out
  // of our .pickup-online-row wrapper after it mounts (confirmed via live
  // DOM inspection: it ends up as a sibling of #ProductInfo-{section.id}
  // instead of staying nested inside the row), so .closest('.pickup-online-row')
  // stops working by the time this script runs. Instead, sections/main-product.liquid
  // renders a hidden <span data-pickup-store-info data-block-id="..."> that stays
  // put in its original position, keyed off the same block.id the app uses in its
  // own element id (id="frengee-pickup-block-{block.id}"). Look that span up by id
  // instead of relying on DOM position.
  // Shopify appends a "-1", "-2", etc. instance suffix to the Liquid-side
  // block.id in some render contexts (confirmed via live DOM inspection:
  // our data-block-id came out as "...UinY9G-1" while the app's own
  // element id was "...UinY9G", no suffix), so an exact string match
  // between the two fails. Strip any trailing "-<digits>" from both sides
  // before comparing.
  function normalizeBlockId(id) {
    return String(id || '').replace(/-\d+$/, '');
  }

  function getStoreInfo(block) {
    var blockId = normalizeBlockId(block.id.replace(/^frengee-pickup-block-/, ''));
    if (!blockId) return null;
    var candidates = document.querySelectorAll('[data-pickup-store-info]');
    for (var i = 0; i < candidates.length; i++) {
      if (normalizeBlockId(candidates[i].getAttribute('data-block-id')) === blockId) {
        return candidates[i];
      }
    }
    return null;
  }

  function extractStoreName(block, titleText) {
    var text = String(titleText || '').trim();
    var labels = [block.dataset.pickupPrefix, block.dataset.unavailableLabel];

    labels.forEach(function (label) {
      if (label && text.indexOf(label) === 0) {
        text = text.slice(label.length);
      }
    });

    return text.replace(/^\s*at\s+/i, '').trim();
  }

  function addStoreNameHeader(block) {
    var title = block.querySelector('[data-frengee-summary-title]');
    var textWrap = block.querySelector('.frengee-pickup__text');
    if (!title || !textWrap) return;

    // Prefer the real name from Shopify's own location settings (see
    // data-pickup-store-info in sections/main-product.liquid) over parsing
    // it out of the app's title text — the parsed version is only a
    // fallback for when that data attribute isn't present.
    var storeInfo = getStoreInfo(block);
    var realName = storeInfo && storeInfo.getAttribute('data-store-name');
    var storeName = realName || extractStoreName(block, title.textContent);
    if (!storeName) return;

    var header = textWrap.querySelector('.frengee-pickup__store-name');
    if (!header) {
      header = document.createElement('p');
      header.className = 'frengee-pickup__store-name';
      textWrap.insertBefore(header, textWrap.firstChild);
    }

    if (header.textContent !== storeName) {
      header.textContent = storeName;
    }
  }

  function addAddressLine(block) {
    var textWrap = block.querySelector('.frengee-pickup__text');
    if (!textWrap || textWrap.querySelector('.frengee-pickup__address')) return;

    // Reuse the same server-computed address used for the map pin (see
    // data-pickup-store-info in sections/main-product.liquid) rather than
    // trying to parse it back out of the app's own text — that's the real,
    // correct address instead of a guess.
    var storeInfo = getStoreInfo(block);
    var address = storeInfo && storeInfo.getAttribute('data-store-address');
    if (!address) return;

    var addressEl = document.createElement('p');
    addressEl.className = 'frengee-pickup__address';
    addressEl.textContent = address;

    var link = block.querySelector('.frengee-pickup__link');
    if (link) {
      link.insertAdjacentElement('beforebegin', addressEl);
    } else {
      textWrap.appendChild(addressEl);
    }
  }

  // Path copied 1:1 from snippets/icon-location.liquid (feather map-pin)
  // so the pickup card icon matches the theme's icon set exactly.
  var LOCATION_ICON_SVG =
    '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-map-pin" aria-hidden="true" focusable="false" role="presentation"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  function addIconBadge(block) {
    var summary = block.querySelector('.frengee-pickup__summary');
    if (!summary || summary.querySelector('.frengee-pickup__icon-badge')) return;

    var badge = document.createElement('span');
    badge.className = 'frengee-pickup__icon-badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML = LOCATION_ICON_SVG;
    summary.insertBefore(badge, summary.firstChild);
  }

  function processAll() {
    document.querySelectorAll('[data-frengee-pickup-block]').forEach(function (block) {
      addStoreNameHeader(block);
      addIconBadge(block);
      addAddressLine(block);
    });
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      processAll();
    });
  }

  schedule();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
